exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter {\n    opacity: 0.01;\n}\n\n.fade-enter.fade-enter-active {\n    opacity: 1;\n    transition: opacity 300ms ease-in;\n}\n\n.fade-exit {\n    opacity: 1;\n}\n\n.fade-exit.fade-exit-active {\n    opacity: 0.01;\n    transition: opacity 300ms ease-in;\n}\n\n\n\n\n.switch-wrapper {\n    position: relative;\n    height: 100%;\n    width: 100%;\n}\n\n.switch-wrapper>div {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n}", ""]);

// exports
